import { Loading } from "@app/components";
import { useSample } from "@app/pages/samples/utils/useSample";
import { errorAlert } from "@app/utils/alerts";
import {
  useAnalysisTypes,
  useReceiver,
  useSamplingPoints,
  useTypesAccumulation,
  useTypeSample,
  useUser,
} from "@services/servicesGenericsTables";
import { useEffect, useRef, useState } from "react";
import { Outlet } from "react-router-dom";

export default function ReportEditLayout() {
  const [loading, setLoading] = useState(true);
  const fetched = useRef(false);

  const { fetchAll } = useReceiver();
  const { fetchAll: fetchAllUser } = useUser();
  const { fetchAll: fetchAllPoints } = useSamplingPoints();
  const { fetchAll: fetchAllTypeSample } = useTypeSample();
  const { fetchAll: fetchAllSamples } = useSample();
  const { fetchAll: fetchAllAccum } = useTypesAccumulation();
  const { fetchAll: fetchAllAnalysis } = useAnalysisTypes();

  useEffect(() => {
    if (!fetched.current) {
      fetched.current = true;
      setLoading(true);

      Promise.all([
        fetchAll(),
        fetchAllUser(),
        fetchAllPoints(),
        fetchAllTypeSample(),
        fetchAllSamples(),
        fetchAllAccum(),
        fetchAllAnalysis(),
      ])
        .then(() => setLoading(false))
        .catch(() => {
          errorAlert("Error al cargar los datos");
          setLoading(false);
        });
    }
  }, []);

  return loading ? <Loading /> : <Outlet />;
}
